// Single source of truth for unit icons. Every import uses the `?url`
// resource query so webpack always emits a real file (see
// webpack/image-loader.js) rather than inlining as a base64 data URI. Most
// of these icons are already over the 8KB inline threshold anyway, so a
// separate "plain" variant bought inlining for only a handful of small
// icons at the cost of importing everything twice — not worth it.
import lockerImage from 'assets/images/unit-icons/locker.svg?url';
import wineImage from 'assets/images/unit-icons/wine.svg?url';
import outdoorImage from 'assets/images/unit-icons/outdoor.svg?url';
import workspaceImage from 'assets/images/unit-icons/workspace.svg?url';

import storage5x5 from 'assets/images/unit-icons/5x5-storage.svg?url';
import storage5x10 from 'assets/images/unit-icons/5x10-storage.svg?url';
import storage5x15 from 'assets/images/unit-icons/5x15-storage.svg?url';
import storage10x10 from 'assets/images/unit-icons/10x10-storage.svg?url';
import storage10x15 from 'assets/images/unit-icons/10x15-storage.svg?url';
import storage10x20 from 'assets/images/unit-icons/10x20-storage.svg?url';
import storage10x30 from 'assets/images/unit-icons/10x30-storage.svg?url';

import parkingSpace10x15 from 'assets/images/unit-icons/10x15-parking_space.svg?url';
import parkingSpace10x20 from 'assets/images/unit-icons/10x20-parking_space.svg?url';
import parkingSpace10x25 from 'assets/images/unit-icons/10x25-parking_space.svg?url';
import parkingSpace10x30 from 'assets/images/unit-icons/10x30-parking_space.svg?url';
import parkingSpace10x35 from 'assets/images/unit-icons/10x35-parking_space.svg?url';
import parkingSpace10x40 from 'assets/images/unit-icons/10x40-parking_space.svg?url';
import parkingSpace10x50 from 'assets/images/unit-icons/10x50-parking_space.svg?url';

import boat10x15 from 'assets/images/icons/boat-storage/10x15--boat-space.svg?url';
import boat10x20 from 'assets/images/icons/boat-storage/10x20--boat-space.svg?url';
import boat10x25 from 'assets/images/icons/boat-storage/10x25--parking-space.svg?url';
import boat10x30 from 'assets/images/icons/boat-storage/10x30--boat-space.svg?url';
import boat10x35 from 'assets/images/icons/boat-storage/10x35--boat-space.svg?url';
import boat10x40 from 'assets/images/icons/boat-storage/10x40--boat-space.svg?url';
import boat10x50 from 'assets/images/icons/boat-storage/10x50--boat-space.svg?url';

const SPECIAL_CASES = {
	locker: lockerImage,
	wine: wineImage,
	outdoor: outdoorImage,
	workspace: workspaceImage,
};

const ICONS = {
	'5x5-storage': storage5x5,
	'5x10-storage': storage5x10,
	'5x15-storage': storage5x15,
	'10x10-storage': storage10x10,
	'10x15-storage': storage10x15,
	'10x20-storage': storage10x20,
	'10x30-storage': storage10x30,
	'5x5-parking_space': parkingSpace10x15,
	'10x15-parking_space': parkingSpace10x15,
	'10x20-parking_space': parkingSpace10x20,
	'10x25-parking_space': parkingSpace10x25,
	'10x30-parking_space': parkingSpace10x30,
	'10x35-parking_space': parkingSpace10x35,
	'10x40-parking_space': parkingSpace10x40,
	'10x50-parking_space': parkingSpace10x50,
	'5x5-boat': boat10x15,
	'10x15-boat': boat10x15,
	'10x20-boat': boat10x20,
	'10x25-boat': boat10x25,
	'10x30-boat': boat10x30,
	'10x35-boat': boat10x35,
	'10x40-boat': boat10x40,
	'10x50-boat': boat10x50,
};

export function chooseIcon(unitSizeText) {
	if (unitSizeText.match('locker')) {
		return SPECIAL_CASES.locker;
	}
	if (unitSizeText.match('wine')) {
		return SPECIAL_CASES.wine;
	}
	if (unitSizeText.match('outdoor')) {
		return SPECIAL_CASES.outdoor;
	}
	if (unitSizeText.match('workspace')) {
		return SPECIAL_CASES.workspace;
	}

	return ICONS[unitSizeText];
}
